import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Button from '@mui/material/Button';
import HomeIcon from '@mui/icons-material/Home';
import ListAltIcon from '@mui/icons-material/ListAlt';
import StorefrontIcon from '@mui/icons-material/Storefront';
import PersonIcon from '@mui/icons-material/Person';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import LogoutIcon from '@mui/icons-material/Logout';
import SensorsIcon from '@mui/icons-material/Sensors';

function logout() {
    localStorage.removeItem('customerToken');
    window.location.href = '/auctions';
}

function CustomerNav() {
    return (
        <>
            <Button component={RouterLink} to="/" color="inherit" startIcon={<HomeIcon />}>Inicio</Button>
            <Button component={RouterLink} to="/auctions" color="inherit" startIcon={<ListAltIcon />}>Subastas</Button>
            <Button component={RouterLink} to="/room/join" color="inherit" startIcon={<SensorsIcon />}>Subasta en Vivo</Button>
            <Button component={RouterLink} to="/gem-store" color="inherit" startIcon={<StorefrontIcon />}>Tienda</Button>
            <Button component={RouterLink} to="/my-profile" color="inherit" startIcon={<PersonIcon />}>Mi Perfil</Button>
            <Button component={RouterLink} to="/my-wins" color="inherit" startIcon={<EmojiEventsIcon />}>Ganados</Button>
            <Button onClick={logout} variant="outlined" color="inherit" startIcon={<LogoutIcon />}>Cerrar Sesión</Button>
        </>
    );
}

export default CustomerNav;
